import { render, staticRenderFns } from "./PlainArgument.vue?vue&type=template&id=85b763e2&scoped=true&"
import script from "./PlainArgument.vue?vue&type=script&lang=js&"
export * from "./PlainArgument.vue?vue&type=script&lang=js&"
import style0 from "./PlainArgument.vue?vue&type=style&index=0&id=85b763e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85b763e2",
  null
  
)

export default component.exports